<template lang="pug">
  div(class="billing-payment-status")
    div(class="billing-payment-status__image")
      v-img(
        :src="image"
        max-width="80"
      )
    div(class="billing-payment-status__content")
      h3(
        class="mb-2"
        :class="[xsDevice ? 'title-20px' : 'title-32px bold']"
      ) {{ title }}
      p(class="text-14px light mb-8") {{ text }}
    div(class="billing-payment-status__actions")
      v-btn(
        height="48"
        @click="secondaryBtnClick"
      ) {{ secondaryButtonText }}
      v-btn(
        class="main-button"
        @click="primaryBtnClick"
      ) {{ buttonText }}
</template>

<script>
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'BillingPaymentStatus',
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    image: {
      type: Image,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    secondaryButtonText: {
      type: String,
      default: null
    },
    onPrimaryClick: {
      type: Function,
      default: null
    },
    onSecondaryClick: {
      type: Function,
      default: null
    }
  },
  methods: {
    primaryBtnClick() {
      if (typeof this.onPrimaryClick === 'function') {
        this.onPrimaryClick()
      }
      this.closeModal(true)
    },
    secondaryBtnClick() {
      if (typeof this.onSecondaryClick === 'function') {
        this.onSecondaryClick()
      }
      this.closeModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
.billing-payment-status {
  &__image {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  &__content {
    text-align: left;
  }

  &__actions {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'md')) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: none;
    }

    &.solo {
      grid-template-rows: 1fr;
      gap: 0;

      @media (min-width: map-get($breakpoints, 'md')) {
        grid-template-columns: 1fr;
        gap: 0;
        grid-template-rows: none;
      }
    }
  }
}
</style>
